import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import Col from 'react-bootstrap/Col';
import { setActiveSlide } from '../../../actions/shared/capsulesData';
import properties from '../../../modules/ajio-util/properties';
import { fetchProducts } from '../../../actions/shared/productsData.js';
import { setRequest } from '../../../actions/shared/request';
import { storageAvailable } from '../storageAvailable';

class CapsuleSlider extends React.Component {
  constructor(props) {
    super(props);
  }

  onActionClick = e => {
    const cp = document.getElementById('capsule-products');
    const cpOffsetTop = cp.offsetTop - 110;
    const element = document.body;
    const duration = 500;
    if (duration <= 0) return;
    const difference = cpOffsetTop - element.scrollTop;
    const perTick = (difference / duration) * 30;

    setTimeout(function() {
      element.scrollTop += perTick;
      if (element.scrollTop === cpOffsetTop) return;
      scrollTo(element, cpOffsetTop, duration - 10);
    }, 10);
  };

  render() {
    const { allcapsules = {} } = this.props;
    const capsuleBannerData = Object.keys(allcapsules).length === 0 ? '' : allcapsules;
    if (Object.keys(capsuleBannerData).length === 0) {
      return null;
    }
    const { capsules = [] } = capsuleBannerData;
    let fetchData = this.props.fetchData;

    // var capsulename = localStorage.getItem("capsulename");

    var slickSettings = {
      arrows: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      swipe: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      lazyLoad: true,
      lazyLoadOffset: 2,
      dots: false,
      afterChange: index => {
        const { allcapsules = {}, request = {} } = this.props;
        const { capsules = [] } = allcapsules;
        const { id: activeSlide = '', imageURL, title } = capsules[index];
        if (activeSlide) {
          this.props.setActiveSlide(activeSlide, imageURL, title);
          this.props.fetchProducts({ request, cid: activeSlide });
        }
      }
    };

    let capsuleImageGallery = capsules.map((data, i) => {
      return (
        <Col
          xs={12}
          key={i}
          ref="capsuleid"
          id={data.id}
          onClick={() => this.onActionClick(data.id)}
        >
          <div className="middle-text">
            <span>{data.title}</span>
          </div>
          <div className="cp-image">
            <img src={`${data.imageURL}`} alt={data.title} title={data.title} />
          </div>
        </Col>
      );
    });

    return (
      <div className="cp-imagecontainer">
        <Slider {...slickSettings} ref="slick">
          {capsuleImageGallery}
        </Slider>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { request = {}, products = {}, productsAdditionalInfo = {}, capsules = {} } = state;
  const { isRequestOrginIsBrowser, hasErrored, errorDetails } = products;
  const { location, history, match = {} } = ownProps;
  const { params = {} } = match;
  const { searchInput } = params;
  return {
    location,
    history,
    request,
    searchInput,
    params,
    isRequestOrginIsBrowser,
    hasErrored,
    errorDetails,
    productsAdditionalInfo,
    allcapsules: capsules
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  // let cId = ownProps.cid;
  return {
    fetchProducts: params =>
      dispatch(
        fetchProducts({
          request: params.request,
          cid: params.cid,
          isRequestOrginIsBrowser: true,
          capsuleLoader: true
        })
      ),
    setRequest: request => {
      dispatch(setRequest(request));
    },
    setActiveSlide: (name, imageURL, title) => {
      dispatch(setActiveSlide(name, imageURL, title));
    }
  };
}

export default CapsuleSlider = connect(mapStateToProps, mapDispatchToProps)(CapsuleSlider);

// export default CapsuleSlider;
